// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.bt-offerWrap {
  width: 100%;
}

/* Banner */
.bt-offerBanner {
  background: #2c2c2c;
  border-bottom: 1px solid #303030;
  padding: 12px 0;
}

.bt-offerInner {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* 上排：左/中/右 */
.bt-offerTopRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
}

.bt-offerLeft {
  padding-top: 2px; /* 視覺平衡 */
}

.bt-offerTitle {
  font-weight: 800;
  color: #fff;
  font-size: 15px;
  line-height: 1.2;
}

.bt-offerSub {
  color: #fff;
  font-size: 12px;
  opacity: 0.8;
  margin-top: 4px;
}

.bt-offerCenter {
  flex: 1 1;
  display: flex;
  justify-content: center;
  transform: translateY(3px); /* 讓倒數視覺落在中線 */
}

.bt-offerRight {
  display: flex;
  align-items: center;
  gap: 10px;
  white-space: nowrap;
}

/* X */
.bt-closeX {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.25);
  background: transparent;
  color: rgba(255, 255, 255, 0.85);
  font-size: 22px;
  line-height: 32px;
  cursor: pointer;
}

.bt-closeX:hover {
  border-color: rgba(255, 255, 255, 0.45);
  color: #fff;
}

/* 倒數 layout */
.bt-flipClock {
  display: flex;
  align-items: center;
  gap: 12px;
}

.bt-flipSep {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  flex: 0 0 14px;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 900;
  font-size: 34px;
  line-height: 1;
  margin-top: -6px;
}

/* Unit */
.bt-flipUnit {
  text-align: center;
}

.bt-flipLabel {
  height: 14px;
  line-height: 14px;
  margin-top: 8px;
  font-size: 11px;
  opacity: 0.75;
  color: #fff;
}

/* Flip Card (桌機更大) */
.bt-flipCard {
  --cardH: 86px;
  --halfH: calc(var(--cardH) / 2);
  position: relative;
  width: 72px;
  height: var(--cardH);
  perspective: 700px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.22);
}

/* 四片 */
.bt-flipTop,
.bt-flipBottom,
.bt-flipTopFlip,
.bt-flipBottomFlip {
  position: absolute;
  left: 0;
  width: 100%;
  height: 50%;
  background: #1f1f1f;
  color: #fff;
  overflow: hidden;
  backface-visibility: hidden;
}

/* 數字：永遠用完整卡片高度置中（關鍵，避免只剩上半部） */
.bt-flipNum {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: var(--cardH);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 900;
  font-size: 40px;
  letter-spacing: 1px;
  line-height: 1;
  color: #fff;
}

/* 上半：直接顯示上半 */
.bt-flipTop {
  top: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}

.bt-flipTop .bt-flipNum,
.bt-flipTopFlip .bt-flipNum {
  transform: none;
}

/* 下半：把整個數字往上移半張高度，裁切露出下半 */
.bt-flipBottom {
  bottom: 0;
  background: #141414;
}

.bt-flipBottom .bt-flipNum,
.bt-flipBottomFlip .bt-flipNum {
  top: calc(-1 * var(--halfH));
  transform: none;
}

/* 翻牌片 */
.bt-flipTopFlip {
  top: 0;
  transform-origin: bottom;
  transform: rotateX(0deg);
  opacity: 0;
}

.bt-flipBottomFlip {
  bottom: 0;
  transform-origin: top;
  transform: rotateX(90deg);
  opacity: 0;
  background: #141414;
}

/* 動畫 */
.bt-flipCard.is-flipping .bt-flipTopFlip {
  opacity: 1;
  animation: btTopFlip 220ms ease-in forwards;
}

.bt-flipCard.is-flipping .bt-flipBottomFlip {
  opacity: 1;
  animation: btBottomFlip 300ms ease-out forwards;
  animation-delay: 220ms;
}

@keyframes btTopFlip {
  0% {
    transform: rotateX(0deg);
  }
  100% {
    transform: rotateX(-90deg);
  }
}
@keyframes btBottomFlip {
  0% {
    transform: rotateX(90deg);
  }
  100% {
    transform: rotateX(0deg);
  }
}
/* 下排：優惠碼 */
.bt-offerBottomRow {
  width: 100%;
}

.bt-offerCodes {
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
}

.bt-copyCodeBtn {
  background: #1f1f1f;
  border: 1px dashed rgba(255, 255, 255, 0.4);
  color: #fff;
  padding: 10px 12px;
  border-radius: 10px;
  cursor: pointer;
  text-align: left;
  min-width: 240px;
}

.bt-copyCodeBtn:hover {
  border-color: rgba(255, 255, 255, 0.85);
}

.bt-copyCodeBtn.is-copied {
  background: #2e7d32;
  border-color: #2e7d32;
}

.bt-copyMain {
  font-size: 13px;
  font-weight: 800;
}

.bt-copySub {
  font-size: 11px;
  opacity: 0.8;
  margin-top: 4px;
}

/* RWD */
@media (max-width: 768px) {
  .bt-offerTopRow {
    flex-wrap: wrap;
    gap: 10px;
  }
  .bt-offerLeft {
    min-width: auto;
    width: 100%;
  }
  .bt-offerCenter {
    width: 100%;
    justify-content: flex-start;
    transform: none;
  }
  .bt-offerRight {
    margin-left: auto;
  }
  .bt-flipCard {
    --cardH: 56px;
    --halfH: calc(var(--cardH) / 2);
    width: 48px;
    border-radius: 10px;
  }
  .bt-flipNum {
    font-size: 26px;
  }
  .bt-flipSep {
    font-size: 28px;
    margin-top: -4px;
  }
  .bt-copyCodeBtn {
    min-width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/offerFlipCountdownBanner.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,WAAA;AAEF;;AACA,WAAA;AACA;EACE,mBAAA;EACA,gCAAA;EACA,eAAA;AAEF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAEF;;AACA,aAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAEF;;AACA;EACE,gBAAA,EAAA,SAAA;AAEF;;AAAA;EACE,gBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAGF;;AADA;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;AAIF;;AADA;EACE,SAAA;EACA,aAAA;EACA,uBAAA;EACA,0BAAA,EAAA,cAAA;AAIF;;AADA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAIF;;AADA,MAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,2CAAA;EACA,uBAAA;EACA,gCAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AAIF;;AAFA;EACE,uCAAA;EACA,WAAA;AAKF;;AAFA,cAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAKF;;AAFA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,cAAA;EACA,+BAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAKF;;AAFA,SAAA;AACA;EACE,kBAAA;AAKF;;AAHA;EACE,YAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;AAMF;;AAHA,qBAAA;AACA;EACE,aAAA;EACA,+BAAA;EAEA,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,0CAAA;AAKF;;AAFA,OAAA;AACA;;;;EAIE,kBAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,2BAAA;AAKF;;AAFA,+BAAA;AACA;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,oBAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;AAGF;;AAAA,cAAA;AACA;EACE,MAAA;EACA,kDAAA;AAGF;;AADA;;EAEE,eAAA;AAIF;;AADA,2BAAA;AACA;EACE,SAAA;EACA,mBAAA;AAIF;;AAFA;;EAEE,4BAAA;EACA,eAAA;AAKF;;AAFA,QAAA;AACA;EACE,MAAA;EACA,wBAAA;EACA,wBAAA;EACA,UAAA;AAKF;;AAFA;EACE,SAAA;EACA,qBAAA;EACA,yBAAA;EACA,UAAA;EACA,mBAAA;AAKF;;AAFA,OAAA;AACA;EACE,UAAA;EACA,2CAAA;AAKF;;AAFA;EACE,UAAA;EACA,+CAAA;EACA,sBAAA;AAKF;;AAFA;EACE;IAAK,wBAAA;EAML;EALA;IAAO,0BAAA;EAQP;AACF;AANA;EACE;IAAK,yBAAA;EASL;EARA;IAAO,wBAAA;EAWP;AACF;AATA,WAAA;AACA;EACE,WAAA;AAWF;;AARA;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;AAWF;;AARA;EACE,mBAAA;EACA,2CAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAWF;;AARA;EACE,uCAAA;AAWF;;AARA;EACE,mBAAA;EACA,qBAAA;AAWF;;AARA;EACE,eAAA;EACA,gBAAA;AAWF;;AARA;EACE,eAAA;EACA,YAAA;EACA,eAAA;AAWF;;AARA,QAAA;AACA;EACE;IACE,eAAA;IACA,SAAA;EAWF;EARA;IACE,eAAA;IACA,WAAA;EAUF;EAPA;IACE,WAAA;IACA,2BAAA;IACA,eAAA;EASF;EANA;IACE,iBAAA;EAQF;EALA;IACE,aAAA;IACA,+BAAA;IACA,WAAA;IACA,mBAAA;EAOF;EAJA;IACE,eAAA;EAMF;EAHA;IACE,eAAA;IACA,gBAAA;EAKF;EAFA;IACE,eAAA;EAIF;AACF","sourcesContent":[".bt-offerWrap {\r\n  width: 100%;\r\n}\r\n\r\n/* Banner */\r\n.bt-offerBanner {\r\n  background: #2c2c2c;\r\n  border-bottom: 1px solid #303030;\r\n  padding: 12px 0;\r\n}\r\n\r\n.bt-offerInner {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n\r\n/* 上排：左/中/右 */\r\n.bt-offerTopRow {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 14px;\r\n}\r\n\r\n.bt-offerLeft {\r\n  padding-top: 2px; /* 視覺平衡 */\r\n}\r\n.bt-offerTitle {\r\n  font-weight: 800;\r\n  color: #fff;\r\n  font-size: 15px;\r\n  line-height: 1.2;\r\n}\r\n.bt-offerSub {\r\n  color: #fff;\r\n  font-size: 12px;\r\n  opacity: 0.8;\r\n  margin-top: 4px;\r\n}\r\n\r\n.bt-offerCenter {\r\n  flex: 1;\r\n  display: flex;\r\n  justify-content: center;\r\n  transform: translateY(3px); /* 讓倒數視覺落在中線 */\r\n}\r\n\r\n.bt-offerRight {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* X */\r\n.bt-closeX {\r\n  width: 36px;\r\n  height: 36px;\r\n  border-radius: 10px;\r\n  border: 1px solid rgba(255, 255, 255, 0.25);\r\n  background: transparent;\r\n  color: rgba(255, 255, 255, 0.85);\r\n  font-size: 22px;\r\n  line-height: 32px;\r\n  cursor: pointer;\r\n}\r\n.bt-closeX:hover {\r\n  border-color: rgba(255, 255, 255, 0.45);\r\n  color: #fff;\r\n}\r\n\r\n/* 倒數 layout */\r\n.bt-flipClock {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.bt-flipSep {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 14px;\r\n  flex: 0 0 14px;\r\n  color: rgba(255, 255, 255, 0.9);\r\n  font-weight: 900;\r\n  font-size: 34px;\r\n  line-height: 1;\r\n  margin-top: -6px;\r\n}\r\n\r\n/* Unit */\r\n.bt-flipUnit {\r\n  text-align: center;\r\n}\r\n.bt-flipLabel {\r\n  height: 14px;\r\n  line-height: 14px;\r\n  margin-top: 8px;\r\n  font-size: 11px;\r\n  opacity: 0.75;\r\n  color: #fff;\r\n}\r\n\r\n/* Flip Card (桌機更大) */\r\n.bt-flipCard {\r\n  --cardH: 86px;\r\n  --halfH: calc(var(--cardH) / 2);\r\n\r\n  position: relative;\r\n  width: 72px;\r\n  height: var(--cardH);\r\n  perspective: 700px;\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.22);\r\n}\r\n\r\n/* 四片 */\r\n.bt-flipTop,\r\n.bt-flipBottom,\r\n.bt-flipTopFlip,\r\n.bt-flipBottomFlip {\r\n  position: absolute;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 50%;\r\n  background: #1f1f1f;\r\n  color: #fff;\r\n  overflow: hidden;\r\n  backface-visibility: hidden;\r\n}\r\n\r\n/* 數字：永遠用完整卡片高度置中（關鍵，避免只剩上半部） */\r\n.bt-flipNum {\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%;\r\n  height: var(--cardH);\r\n\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n\r\n  font-weight: 900;\r\n  font-size: 40px;\r\n  letter-spacing: 1px;\r\n  line-height: 1;\r\n  color: #fff;\r\n}\r\n\r\n/* 上半：直接顯示上半 */\r\n.bt-flipTop {\r\n  top: 0;\r\n  border-bottom: 1px solid rgba(255, 255, 255, 0.12);\r\n}\r\n.bt-flipTop .bt-flipNum,\r\n.bt-flipTopFlip .bt-flipNum {\r\n  transform: none;\r\n}\r\n\r\n/* 下半：把整個數字往上移半張高度，裁切露出下半 */\r\n.bt-flipBottom {\r\n  bottom: 0;\r\n  background: #141414;\r\n}\r\n.bt-flipBottom .bt-flipNum,\r\n.bt-flipBottomFlip .bt-flipNum {\r\n  top: calc(-1 * var(--halfH));\r\n  transform: none;\r\n}\r\n\r\n/* 翻牌片 */\r\n.bt-flipTopFlip {\r\n  top: 0;\r\n  transform-origin: bottom;\r\n  transform: rotateX(0deg);\r\n  opacity: 0;\r\n}\r\n\r\n.bt-flipBottomFlip {\r\n  bottom: 0;\r\n  transform-origin: top;\r\n  transform: rotateX(90deg);\r\n  opacity: 0;\r\n  background: #141414;\r\n}\r\n\r\n/* 動畫 */\r\n.bt-flipCard.is-flipping .bt-flipTopFlip {\r\n  opacity: 1;\r\n  animation: btTopFlip 220ms ease-in forwards;\r\n}\r\n\r\n.bt-flipCard.is-flipping .bt-flipBottomFlip {\r\n  opacity: 1;\r\n  animation: btBottomFlip 300ms ease-out forwards;\r\n  animation-delay: 220ms;\r\n}\r\n\r\n@keyframes btTopFlip {\r\n  0% { transform: rotateX(0deg); }\r\n  100% { transform: rotateX(-90deg); }\r\n}\r\n\r\n@keyframes btBottomFlip {\r\n  0% { transform: rotateX(90deg); }\r\n  100% { transform: rotateX(0deg); }\r\n}\r\n\r\n/* 下排：優惠碼 */\r\n.bt-offerBottomRow {\r\n  width: 100%;\r\n}\r\n\r\n.bt-offerCodes {\r\n  display: flex;\r\n  gap: 12px;\r\n  justify-content: center;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.bt-copyCodeBtn {\r\n  background: #1f1f1f;\r\n  border: 1px dashed rgba(255, 255, 255, 0.4);\r\n  color: #fff;\r\n  padding: 10px 12px;\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n  text-align: left;\r\n  min-width: 240px;\r\n}\r\n\r\n.bt-copyCodeBtn:hover {\r\n  border-color: rgba(255, 255, 255, 0.85);\r\n}\r\n\r\n.bt-copyCodeBtn.is-copied {\r\n  background: #2e7d32;\r\n  border-color: #2e7d32;\r\n}\r\n\r\n.bt-copyMain {\r\n  font-size: 13px;\r\n  font-weight: 800;\r\n}\r\n\r\n.bt-copySub {\r\n  font-size: 11px;\r\n  opacity: 0.8;\r\n  margin-top: 4px;\r\n}\r\n\r\n/* RWD */\r\n@media (max-width: 768px) {\r\n  .bt-offerTopRow {\r\n    flex-wrap: wrap;\r\n    gap: 10px;\r\n  }\r\n\r\n  .bt-offerLeft {\r\n    min-width: auto;\r\n    width: 100%;\r\n  }\r\n\r\n  .bt-offerCenter {\r\n    width: 100%;\r\n    justify-content: flex-start;\r\n    transform: none;\r\n  }\r\n\r\n  .bt-offerRight {\r\n    margin-left: auto;\r\n  }\r\n\r\n  .bt-flipCard {\r\n    --cardH: 56px;\r\n    --halfH: calc(var(--cardH) / 2);\r\n    width: 48px;\r\n    border-radius: 10px;\r\n  }\r\n\r\n  .bt-flipNum {\r\n    font-size: 26px;\r\n  }\r\n\r\n  .bt-flipSep {\r\n    font-size: 28px;\r\n    margin-top: -4px;\r\n  }\r\n\r\n  .bt-copyCodeBtn {\r\n    min-width: 100%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
